import { HttpClient } from "@angular/common/http";
import dayjs from "dayjs";
import { Observable } from "rxjs";

import { StorageService } from '../../shared/services/storage.service';

import { registerLocaleData } from '@angular/common';
import localePl from '@angular/common/locales/pl';
registerLocaleData(localePl, 'pl');
import localeZh from '@angular/common/locales/zh';
registerLocaleData(localeZh, 'zh');

import utc from "dayjs/plugin/utc";
import localeData from 'dayjs/plugin/localeData';
import isBetween from 'dayjs/plugin/isBetween';
import { TranslateLoader } from "@ngx-translate/core";

dayjs.extend(utc);
dayjs.extend(localeData);
dayjs.extend(isBetween);

export class LanguageLoader extends TranslateLoader {
    prefix = "./assets/i18n/";
    suffix = `.json?t=${dayjs().unix()}`;

    constructor(private readonly http: HttpClient, private storageService: StorageService) {
        super();
    }

    getTranslation(lang: string): Observable<Object> {
        return this.http.get(`${this.prefix}${lang}${this.suffix}`);
    }

    setLanguage(): string {
        const lang = this.storageService.getStorage(this.storageService.idLanguage)?.replace(/['"]+/g, '') ?? "en";
        dayjs.locale(lang);
        return lang;
    }
}
